exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".App__1ABKx{background:#fbfbfb;height:100%}", "", {"version":3,"sources":["/usr/src/app/src/components/App/App.scss"],"names":[],"mappings":"AAAA,YACI,mBACA,WAAY,CACf","file":"App.scss","sourcesContent":[".App {\n    background: #fbfbfb;\n    height: 100%;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"App": "App__1ABKx"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/App/App.scss
// module id = CJg5
// module chunks = 0